import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface GaugeChartProps {
  value: number; // 0-5
  maxValue?: number;
  label: string;
  color: string;
  subtitle?: string;
}

export const GaugeChart: React.FC<GaugeChartProps> = ({
  value,
  maxValue = 5,
  label,
  color,
  subtitle,
}) => {
  const percentage = Math.min(value / maxValue, 1);
  const data = [
    { value: percentage * 100 },
    { value: (1 - percentage) * 100 },
  ];

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-full max-w-[120px]">
        <ResponsiveContainer width="100%" height={80}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy={70}
              startAngle={180}
              endAngle={0}
              innerRadius={35}
              outerRadius={50}
              dataKey="value"
              stroke="none"
            >
              <Cell fill={color} />
              <Cell fill="#e5e7eb" />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 text-center whitespace-nowrap">
          <span className="text-lg font-bold text-gray-800 dark:text-gray-200">
            {value.toFixed(1)}
          </span>
          <span className="text-xs text-gray-500 dark:text-gray-400">
            coef.
          </span>
        </div>
      </div>
      <div className="text-center mt-1">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </span>
        {subtitle && (
          <span className="text-xs text-gray-400 dark:text-gray-500 block">
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};
